'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _detail = require('./detail');

var _mainOverview = require('./main-overview');

var _newsByTag = require('./news-by-tag');

var _newsAside = require('./components/news-aside');

var _newsRecentPopular = require('./components/news-recent-popular');

var _newsGrid = require('./components/news-grid');

var _newsOverview = require('./components/news-overview');

var _newsTags = require('./components/news-tags');

var _newsTile = require('./components/news-tile');

var _newsTileShort = require('./components/news-tile-short');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.news', []).config(["$stateProvider", function ($stateProvider) {
    'ngInject';

    $stateProvider.state('general.news', {
        url: '/news?page&categoryId&searchValue',
        views: {
            'main@root': {
                component: 'mainNewsOverview'
            }
        },
        reloadOnSearch: false,
        params: {
            page: {
                value: '1',
                squash: true
            },
            categoryId: {
                value: '0',
                squash: true
            },
            searchValue: {
                value: '',
                squash: true
            }
        },
        ncyBreadcrumb: {
            label: '{{"News" | translate}}'
        },
        doNotTrack: true
    }).state('general.newsbytag', {
        url: '/news/tag/{id:int}?page&categoryId&searchValue',
        views: {
            'main@root': {
                component: 'newsByTag'
            }
        },
        reloadOnSearch: false,
        params: {
            page: {
                value: '1',
                squash: true
            },
            categoryId: {
                value: '0',
                squash: true
            },
            searchValue: {
                value: '',
                squash: true
            }
        }
    }).state('general.news.newsitem', {
        url: '/{newsItemId:int}',
        views: {
            'main@root': {
                component: 'news'
            }
        },
        resolve: {
            newsdetail: ["$stateParams", "newsService", function newsdetail($stateParams, newsService) {
                return newsService.getById($stateParams.newsItemId).then(function (newsdetail) {
                    return newsdetail;
                });
            }]
        },
        ncyBreadcrumb: {
            label: '{{$resolve.newsdetail.title | translate}}'
        }
    });
}]).component('news', _detail.newsDetail).component('mainNewsOverview', _mainOverview.mainNewsOverviewComponent).component('newsByTag', _newsByTag.newsByTagComponent).component('newsOverview', _newsOverview.newsOverviewComponent).component('newsRecentPopular', _newsRecentPopular.newsRecentPopularComponent).component('newsAside', _newsAside.newsAsideComponent).component('newsGrid', _newsGrid.newsGridComponent).component('newsTags', _newsTags.newsTagsComponent).component('newsTile', _newsTile.newsTileComponent).component('newsTileShort', _newsTileShort.newsTileShortComponent);

exports.default = _module.name;


//////////////////
// WEBPACK FOOTER
// ./features/news/index.js
// module id = 952
// module chunks = 0